const camapaigns = 
{
      "level_up_campaigns": [
        {
          "title": "CHILDHOOD RESCUE",
          "description": "Survive. Recover. And Build a Future. In the world’s most dangerous places, life can change in an instant. Five years later after the Marawi siege, thousands of homeless children and their families are still recovering from its impact.",
          "image": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-childhood-rescue.jpg",
          "area": "Marawi and Cotabato City",
          "target_amount": [
            {
              "amount": "50000",
              "description": "Safe Play Space"
            },
            {
              "amount": "70000",
              "description": "Bridge Construction"
            },
            {
              "amount": "100000",
              "description": "Health Center Expansion"
            }
          ],
          "footer": "You have the power to make this a reality!",
          "color": "#00acca",
          "button_class": "orange-btn"
        },
        {
          "title": "START UP",
          "description": "Empowering families to generate their own sustainable income is part of our development work in the communities we serve. We look forward to livelihood success stories and transformation.",
          "image": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-start-up.jpg",
          "area": "Nationwide",
          "target_amount": [
            {
              "amount": "50000",
              "description": "Joy2Cart - Resell their products!"
            },
            {
              "amount": "70000",
              "description": "Livelihood Starting Capital (Equipment)"
            },
            {
              "amount": "100000",
              "description": "Micro-Financing (ComSCA) Summit"
            }
          ],
          "footer": "You have the power to make this a reality!",
          "color": "#46bb95",
          "button_class": "orange-btn"
        },
        {
          "title": "STUDY UP",
          "description": "Still with the lingering effects of the COVID-19 pandemic, along with local catastrophes, children have become more at risk in terms of their learning and development, due to the disruption and inaccessibility to education.",
          "image": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-study-up.jpg",
          "area": "Nationwide",
          "target_amount": [
            {
              "amount": "50000",
              "description": "Volunteering Activities"
            },
            {
              "amount": "70000",
              "description": "New Normal Education Needs"
            },
            {
              "amount": "100000",
              "description": "School Facilities"
            }
          ],
          "footer": "You have the power to make this a reality!",
          "color": "#ff6b00",
          "button_class": "blue-btn"
        },
        {
          "title": "WASH UP",
          "description": "Malnutrition has been on the rise. Especially on children under the age of five, inadequate food and infectious diseases have a long-lasting effect on their height, weight and overall growth.",
          "image": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-wash-up.jpg",
          "area": "Pangasinan, Camarines Norte, Bukidnon, Sultan Kudarat, Batangas",
          "target_amount": [
            {
              "amount": "50000",
              "description": "Combat Malnutrition Program"
            },
            {
              "amount": "70000",
              "description": "Go Baby Go! Parenting Training"
            },
            {
              "amount": "100000",
              "description": "Handwashing Facilities"
            }
          ],
          "footer": "You have the power to make this a reality!",
          "color": "#9054a1",
          "button_class": "orange-btn"
        },
        {
          "title": "STAND UP",
          "description": "A world without violence against children is possible. We are working to achieve it by empowering communities to promote peacebuilding and protecting children from harm, abuse, child labor and sexual exploitation.",
          "image": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-stand-up.jpg",
          "area": "Nationwide",
          "target_amount": [
            {
              "amount": "50000",
              "description": "School-based Training"
            },
            {
              "amount": "70000",
              "description": "Community-based Training"
            },
            {
              "amount": "100000",
              "description": "Child Helpline and Daycare Facility"
            }
          ],
          "footer": "You have the power to make this a reality!",
          "color": "#006661",
          "button_class": "orange-btn"
        },
        {
          "title": "DAPAT READY",
          "description": "Disasters disrupt children’s lives and deprive them of food, shelter, education, and their most basic needs. We operate on the ground to deliver life-saving aid and skills assistance before, during, and after disasters to help children and their families become more resilient to natural and man made calamities.",
          "image": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-dapat-handa.jpg",
          "area": "Nationwide",
          "target_amount": [
            {
              "amount": "50000",
              "description": "Pre-positioned Relief Items"
            },
            {
              "amount": "70000",
              "description": "Disaster Response Training"
            },
            {
              "amount": "100000",
              "description": "School Covered Court Improvement"
            }
          ],
          "footer": "You have the power to make this a reality!",
          "color": "#842e14",
          "button_class": "orange-btn"
        }
      ],
      "desktop_banner": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-banner.jpg",
      "mobile_banner": "https://cms.worldvision.org.ph/wp-content/uploads/2023/05/levelup-banner-mobile.jpg"
  }

const google_analytics = {
    ga_client_id: '1914666454.1674648667',
    utmString:'utm_source:=www.worldvision.org.ph',
}

const store = {
    camapaigns
}

export default store